export class StripeSubscriptionPlan {
  id: string;
  billingScheme: string;
  interval: string;
  intervalCount: number;
  nickname: string;
  product: string;
}
